export function stringsMatch(...strings){
    return strings.reduce( ({passed,prev},str) => {
        prev === undefined || prev === null ? prev = str : prev;
        return {passed: !passed ? passed : (str === null ? 'null' : str).toString() === (prev === null ? 'null' : prev).toString(), prev:str};
    },{passed:true,prev:undefined}).passed;
}

export function stringCombine(...strings){
    return strings.join('');
}

export function idFrom(keys){
    return (obj) => keys.map(key => obj[key]).join('');
}

export function scopedObject(keys){
    return (obj) => keys.reduce((hold,key) => ({...hold,[key]:obj[key]}),{});
}

export function numbersAdd(...numbers){
    return numbers.reduce( (prev,number) => makeNumber(prev) + makeNumber(number),0);
}

export function numbersSubtract(init,...numbers){
    return numbers.reduce( (prev,number) => makeNumber(prev) - makeNumber(number),init);
}

function makeNumber(input){
    let number = parseFloat(input);
    return isNaN(number) ? 0 : number;
}